import { render, staticRenderFns } from "./GoodsSpecNumSelectForm.vue?vue&type=template&id=b8ede214"
import script from "./GoodsSpecNumSelectForm.vue?vue&type=script&lang=js"
export * from "./GoodsSpecNumSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports